import { render, staticRenderFns } from "./YourEvents.vue?vue&type=template&id=94b5a628"
import script from "./YourEvents.vue?vue&type=script&lang=js"
export * from "./YourEvents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports